import PageHeader from 'src/components/page-header/page-header';

export default function ManualOperationsHeader() {
  return <PageHeader title="Operações Manuais" />;
}